import { Link, useLocation } from "react-router-dom"
import {
  Flex,
  Text,
  Box,
  Tabs,
  TabList,
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Icon,
  HStack,
  FormControl,
  InputGroup,
  Input,
  InputRightElement,
  Select,
  Switch,
  Stack,
  Skeleton,
} from "@chakra-ui/react"
import { PlusIcon, ChevronDownIcon } from "@heroicons/react/solid"
import { PencilIcon, TrashIcon, SearchIcon, ClipboardListIcon } from "@heroicons/react/outline"
import { useEffect, useState } from "react"
import { getClasses, changeStatusClassByClassId, deleteClassByClassId } from "../../api/classes"
import { getCategories } from "../../api/category"
import { DeleteAlert } from "../../components/Alert"

const menuClass = ["Semua", "Aktif", "Nonaktif"]
const useQuery = () => new URLSearchParams(useLocation().search)

export default function List() {
  const shows = [5, 10, 20, 50]
  const [query, setQuery] = useState({
    page: 0,
    show: 5,
    category: "",
    tab: "0",
    search: "",
    admin: true,
  })
  const [classes, setClasses] = useState({ data: [], error: null, isLoading: false })
  const [categories, setCategories] = useState({ data: [], error: null, isLoading: false })
  const [deleteModal, setDeleteModal] = useState({ isOpen: false, isLoading: false, classId: "" })
  const [pagination, setPagination] = useState({ totalItems: 0, totalPages: 0, currentPage: 0 })

  useEffect(() => {
    const GetClasses = async () => {
      setClasses({ ...classes, isLoading: true })
      let active = ""
      if (query.tab === "1") {
        active = "true"
      } else if (query.tab === "2") {
        active = "false"
      }
      const result = await getClasses({ ...query, active })
      if (result.success === true) {
        const { totalItems, totalPages, currentPage } = result.data
        setClasses({ ...classes, data: result.data.classes, isLoading: false })
        setPagination({ totalItems, totalPages, currentPage })
      }
    }
    GetClasses()
    return () => {
      setClasses({ data: [], error: null, isLoading: false })
      setPagination({ totalItems: 0, totalPages: 0, currentPage: 0 })
    }
  }, [query])

  useEffect(() => {
    const GetCategories = async () => {
      setCategories({ ...categories, isLoading: true })
      const { success, data } = await getCategories()
      if (success) {
        setCategories({ ...categories, data: data.categories, isLoading: false })
      }
    }
    GetCategories()
  }, [])

  const submitDeleteClass = async (id) => {
    setDeleteModal({ ...deleteModal, isLoading: true })
    const result = await deleteClassByClassId(id)
    if (result.success) {
      setDeleteModal({ ...deleteModal, isOpen: false, isLoading: false })
      setClasses({ ...classes, data: classes.data.filter((dataClass) => dataClass.id !== id) })
    }
  }

  const changeStatusClass = async (id) => {
    await changeStatusClassByClassId(id)
  }

  return (
    <Flex direction="column">
      <Text color="gray.750" fontSize="2xl" fontWeight="medium">
        Kelas
      </Text>
      <Box bg="white" mt="4" px={[4, 5, 6]} py={8}>
        <Flex direction="column" minH="70vh">
          <Flex direction="row" justify="space-between">
            <Text color="gray.750" fontSize="xl" fontWeight="medium">
              Daftar Kelas
            </Text>
            <Link to="/class/create">
              <Button mt={["2", "0"]}>
                Tambah Kelas
                <Icon as={PlusIcon} h="5" w="5" ml="2" />
              </Button>
            </Link>
          </Flex>
          <Flex direction="column" mt={2}>
            <Tabs overflowX="auto">
              <TabList>
                {menuClass.map((menu, index) => (
                  <Link to={`/class?tab=${index}`} key={index}>
                    <Box
                      p={4}
                      borderBottom={
                        parseInt(useQuery().get("tab")) === index || (useQuery().get("tab") === null && index === 0)
                          ? "2px"
                          : "none"
                      }
                      borderBottomColor={
                        parseInt(useQuery().get("tab")) === index || (useQuery().get("tab") === null && index === 0)
                          ? "purple.450"
                          : ""
                      }
                      position="relative"
                      mb="-2px"
                      onClick={() => setQuery({ ...query, tab: index.toString() })}
                    >
                      <Text
                        color={useQuery().get("tab") === index ? "purple.450" : "gray.750"}
                        fontSize="sm"
                        fontWeight="medium"
                      >
                        {menu}
                      </Text>
                    </Box>
                  </Link>
                ))}
              </TabList>
            </Tabs>
            <Stack direction={["column", "row"]} justify="space-between" py={8}>
              <Flex w={["full", "xs"]}>
                <FormControl w="2xl">
                  <Select
                    placeholder="Pilih Kategori"
                    onChange={(e) => setQuery({ ...query, category: e.target.value })}
                  >
                    {categories.data.map((category, index) => (
                      <option value={category.slug} key={index}>
                        {category.name}
                      </option>
                    ))}
                  </Select>
                </FormControl>
                <FormControl ml="2">
                  <Select onChange={(e) => setQuery({ ...query, show: e.target.value })}>
                    {shows.map((show, index) => (
                      <option value={show} key={index}>
                        {show}
                      </option>
                    ))}
                  </Select>
                </FormControl>
              </Flex>
              <FormControl width={["full", "xs"]}>
                <InputGroup>
                  <Input
                    type="text"
                    placeholder="Search"
                    onChange={(e) => {
                      if (e.target.value.length === 0 || e.target.value.length >= 3) {
                        return setQuery({ ...query, search: e.target.value })
                      }
                    }}
                  />
                  <InputRightElement>
                    <Button variant="ghost" _focus={{ boxShadow: "none" }}>
                      <Icon as={SearchIcon} color="gray.550" h="4" w="4" />
                    </Button>
                  </InputRightElement>
                </InputGroup>
              </FormControl>
            </Stack>
            <Flex overflowX="auto" overflowY="hidden" direction="column">
              {classes.isLoading && (
                <Stack spacing={6}>
                  {[...Array(6)].map((e, i) => (
                    <Stack key={i}>
                      <Skeleton startColor="gray.100" endColor="gray.200" height="30px" />
                    </Stack>
                  ))}
                </Stack>
              )}
              {!classes.isLoading && (
                <Table variant="simple" size="md" mb={4}>
                  <Thead>
                    <Tr color="gray.100" borderTop="1px">
                      <Th fontSize="14px" fontWeight="semibold" color="gray.550">
                        NAMA
                      </Th>
                      <Th fontSize="14px" fontWeight="semibold" color="gray.550">
                        HARGA
                      </Th>
                      <Th fontSize="14px" fontWeight="semibold" color="gray.550">
                        TIPE
                      </Th>
                      <Th fontSize="14px" fontWeight="semibold" color="gray.550">
                        AKTIF
                      </Th>
                      <Th></Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {classes.data.map((classData, index) => (
                      <Tr key={index} fontSize="sm" color="gray.550">
                        <Td fontWeight="semibold">{classData.name}</Td>
                        <Td>Rp. {classData.price.price}</Td>
                        <Td textTransform="capitalize">{classData.type}</Td>
                        <Td>
                          <Switch
                            size="lg"
                            onChange={() => changeStatusClass(classData.id)}
                            defaultChecked={classData.isActive}
                          />
                        </Td>
                        <Td>
                          <Menu>
                            <MenuButton
                              px={4}
                              py={2}
                              transition="all 0.2s"
                              borderRadius="md"
                              borderWidth="1px"
                              _focus={{ boxShadow: "none" }}
                              fontWeight="semibold"
                            >
                              Atur
                              <Icon ml="2" as={ChevronDownIcon} h="5" w="5" />
                            </MenuButton>
                            <MenuList>
                              <Link to={`/class/${classData.id}/create-content`}>
                                <MenuItem>
                                  <HStack w="full">
                                    <Icon as={ClipboardListIcon} h="4" w="4" />
                                    <Text>Atur Content</Text>
                                  </HStack>
                                </MenuItem>
                              </Link>
                              <Link to={`/class/update/${classData.id}`}>
                                <MenuItem>
                                  <HStack w="full">
                                    <Icon as={PencilIcon} h="4" w="4" />
                                    <Text>Edit</Text>
                                  </HStack>
                                </MenuItem>
                              </Link>
                              <MenuItem>
                                <HStack
                                  onClick={() =>
                                    setDeleteModal({ ...deleteModal, isOpen: true, classId: classData.id })
                                  }
                                  w="full"
                                >
                                  <Icon as={TrashIcon} h="4" w="4" />
                                  <Text>Hapus</Text>
                                </HStack>
                              </MenuItem>
                            </MenuList>
                          </Menu>
                        </Td>
                      </Tr>
                    ))}
                  </Tbody>
                  <Tfoot></Tfoot>
                </Table>
              )}
            </Flex>
          </Flex>
        </Flex>
        <Stack spacing="2" direction={["column", "row"]} justify="space-between" mt="4">
          <Text fontSize="sm" color="gray.550">
            Menampilkan 1 sampai {query.show} dari {pagination.totalItems} data
          </Text>
          {pagination.totalItems > query.show && (
            <Stack direction="row" spacing="1">
              {pagination.currentPage > 0 && (
                <Button variant="outline" onClick={() => setQuery({ ...query, page: query.page - 1 })}>
                  Sebelumnya
                </Button>
              )}
              {[...Array(pagination.totalPages)].map((e, i) => (
                <Button
                  variant={i === pagination.currentPage ? "solid" : "outline"}
                  onClick={() => setQuery({ ...query, page: i })}
                  key={i}
                >
                  {i + 1}
                </Button>
              ))}
              {pagination.currentPage < pagination.totalPages - 1 && (
                <Button variant="outline" onClick={() => setQuery({ ...query, page: query.page + 1 })}>
                  Berikutnya
                </Button>
              )}
            </Stack>
          )}
        </Stack>
      </Box>
      <DeleteAlert
        isOpen={deleteModal.isOpen}
        title="Kelas"
        isLoading={deleteModal.isLoading}
        action={() => submitDeleteClass(deleteModal.classId)}
        setOpen={setDeleteModal}
      />
    </Flex>
  )
}
